import Tooltip from "@mui/material/Tooltip";
import { formatValue } from "../../utils/currencyUtils";

const clamp = (value, min = 0, max = 100) =>
  Math.min(Math.max(value, min), max);

const StockBar = (props) => {
  const {
    stock: stockProp,
    currentStock,
    min_stock,
    max_stock,
    projected_stock,
    minStock,
    maxStock,
    projectedStock,
    lebelColor,
    source
  } = props;

  let rawStock = stockProp !== undefined ? stockProp : currentStock;
  let rawMin = min_stock !== undefined ? min_stock : minStock;
  let rawMax = max_stock !== undefined ? max_stock : maxStock;
  let rawProjected =
    projected_stock !== undefined ? projected_stock : projectedStock;

  if (rawStock && typeof rawStock === "object") {
    if (rawStock.current !== undefined) rawStock = rawStock.current;
    if (rawStock.min !== undefined && (rawMin === undefined || rawMin === null))
      rawMin = rawStock.min;
    if (rawStock.max !== undefined && (rawMax === undefined || rawMax === null))
      rawMax = rawStock.max;
    if (
      rawStock.projected !== undefined &&
      (rawProjected === undefined || rawProjected === null)
    )
      rawProjected = rawStock.projected;
  }

  const toNumOrNull = (v) =>
    v !== undefined && v !== null && v !== "" ? Number(v) : null;

  const currentNum = toNumOrNull(rawStock);
  const minNum = toNumOrNull(rawMin);
  const maxNum = toNumOrNull(rawMax);
  const projectedNum = toNumOrNull(rawProjected);

  const safeMax =
    (maxNum != null ? maxNum : currentNum != null ? currentNum : 1) || 1;

  const stockPercent = clamp(
    ((currentNum != null ? currentNum : 0) / safeMax) * 100
  );
  const minPercent = clamp(((minNum != null ? minNum : 0) / safeMax) * 100);
  const projectedPercent = clamp(
    ((projectedNum != null ? projectedNum : 0) / safeMax) * 100
  );

  let barColor = "#BDBDBD";

  if (currentNum != null) {
    if (currentNum === 0) {
      barColor = "#f44336";
    } else if (minNum != null && currentNum < minNum) {
      barColor = "#ff9800";
    } else if (maxNum != null && currentNum > maxNum) {
      barColor = "#ab43bc";
    } else {
      barColor = "#4caf50";
    }
  }
  const visibleFillPercent = currentNum === 0 ? 1 : stockPercent;
  if (process.env.NODE_ENV !== "production") {
    console.debug(
      "currentNum:",
      currentNum,
      "barColor:",
      barColor,
      "visibleFillPercent:",
      visibleFillPercent
    );
  }

  const tooltip = (
    <div>
      <div>
        <strong>Current:</strong> {currentNum != null ? formatValue(currentNum) : " "}
      </div>
      <div>
        <strong>Min:</strong> {minNum != null ? formatValue(minNum) : " "}
      </div>
      <div>
        <strong>Max:</strong> {maxNum != null ? formatValue(maxNum) : " "}
      </div>
      <div>
        <strong>Projected:</strong> {projectedNum != null ? formatValue(projectedNum) : " "}
      </div>
    </div>
  );

  const markers = [
    { pos: minPercent, color: "#777", show: minNum != null },
    { pos: stockPercent, color: "#000", show: currentNum != null },
    { pos: projectedPercent, color: "#9c27b0", show: projectedNum != null },
    { pos: 100, color: "#333", show: maxNum != null },
  ];

  return (
    <Tooltip title={tooltip} arrow
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "#333",
            color: "#fff",
            fontSize: 13,
            padding: "10px 14px",
            borderRadius: 2,
            boxShadow: "0px 3px 8px rgba(0,0,0,0.25)",
            border: "1px solid #555",
            maxWidth: 300,
          },
        },
        arrow: {
          sx: {
            color: "#333",
          },
        },
      }} >
      <div style={{
        display: "flex",
        justifyContent: source === "list" ? "flex-end" : "center",
        alignItems: "center",
        gap: 10
      }}>
        <span
          style={{
            fontWeight: 600,
            fontSize: 13,
            // REMOVED fixed width and margin-right for flexibility
            whiteSpace: "nowrap", // Added to ensure value doesn't wrap
            textAlign: "right",
            userSelect: "none",
            color: currentNum != null ? lebelColor : undefined,
          }}
        >
          {currentNum != null ? formatValue(currentNum) : " "}
        </span>

        <div
          style={{
            position: "relative",
            width: source === "list" ? 120 : 150,         // The fixed width for the stock bar itself
            height: 16,
            minHeight: 16,
            backgroundColor: "#e0e0e0",
            borderRadius: 4,
            overflow: "visible",
          }}
        >
          <div
            style={{
              width: `${visibleFillPercent}%`,
              height: "100%",
              backgroundColor: barColor,
              transition: "width 0.2s ease-in-out",
              borderRadius: 4,
              position: "relative",
              zIndex: 3,
            }}
          />
          {markers.map(({ pos, color, show }, i) =>
            show ? (
              <div
                key={i}
                style={{
                  position: "absolute",
                  left: `calc(${pos}% - 1px)`,
                  top: 0,
                  bottom: 0,
                  width: 2,
                  backgroundColor: color,
                  borderRadius: 1,
                  zIndex: 2,
                  pointerEvents: "none",
                }}
              />
            ) : null
          )}
        </div>
      </div>
    </Tooltip>
  );
};

export default StockBar;